// 导入normal 和remove-fill 的所有svg

const normal = require.context('./normal', false, /\.svg$/);
const removeFill = require.context('./remove-fill', false, /\.svg$/);


const requireAll = (requireContext) => {
	return requireContext.keys().map(requireContext);
};

requireAll(normal);
requireAll(removeFill);